/* ============================================================
   Pholoh shop controls — ON BODY + IN STOCK toggles.
   Both are pure CSS-class flips on the collection grid container,
   so there are no extra network requests and no layout thrash.
   - ON BODY  -> .pholoh-on-body   (CSS reveals the on-model image)
   - IN STOCK -> .pholoh-instock-only (CSS hides [data-available="false"])
   State persists per-session so it survives pagination reloads.
   ============================================================ */
(function () {
  'use strict';

  var KEY_BODY = 'pholoh:onbody';
  var KEY_STOCK = 'pholoh:instock';

  function store(k, v) {
    try { sessionStorage.setItem(k, v ? '1' : ''); } catch (e) {}
  }
  function recall(k) {
    try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; }
  }

  function grid() {
    return document.querySelector('[data-section-type="collection-grid"]') || document.body;
  }

  function applyOnBody(on, input) {
    grid().classList.toggle('pholoh-on-body', on);
    if (input) input.checked = on;
  }
  function applyInStock(on, input) {
    grid().classList.toggle('pholoh-instock-only', on);
    if (input) input.checked = on;
  }

  function init() {
    var bar = document.querySelector('[data-pholoh-shop-controls]');
    if (!bar) return;

    var onbodyInput = bar.querySelector('[data-psc-onbody]');
    var instockInput = bar.querySelector('[data-psc-instock]');

    // restore persisted state
    applyOnBody(recall(KEY_BODY), onbodyInput);
    applyInStock(recall(KEY_STOCK), instockInput);

    if (onbodyInput) {
      onbodyInput.addEventListener('change', function () {
        applyOnBody(onbodyInput.checked, onbodyInput);
        store(KEY_BODY, onbodyInput.checked);
      });
    }
    if (instockInput) {
      instockInput.addEventListener('change', function () {
        applyInStock(instockInput.checked, instockInput);
        store(KEY_STOCK, instockInput.checked);
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
